import { useLazyQuery } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { UpliftFilterInput } from '@/graphql/contracts/_generated_/contracts';
import { GetPaginatedFilteredUplifts, GetPaginatedFilteredUpliftsVariables }
  from '@/graphql/contracts/_generated_/getPaginatedFilteredUplifts.query';
import { notificationService } from '@/services/notification/notification.client';
import { PaginatedFilteredGridData } from '@/utils/data-helpers/PaginatedFilteredGridData';
import GetPaginatedUpliftsQuery from '@/graphql/contracts/getPaginatedFilteredUplifts.query.gql';

export type PaginatedFilteredUplifts = PaginatedFilteredGridData<UpliftFilterInput>;

export default function useGetUplifts() {
  const [_getUplifts] = useLazyQuery<
  GetPaginatedFilteredUplifts,
  GetPaginatedFilteredUpliftsVariables
  >(GetPaginatedUpliftsQuery, {
    client: apolloClientContracts,
    fetchPolicy: 'network-only',
    onError: (err) =>
      notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger',
      }),
  });

  const getUplifts = async (params: PaginatedFilteredUplifts) => {
    const response = await _getUplifts({
      variables: {
        ...params,
      } as GetPaginatedFilteredUpliftsVariables,
    });
    return response.data?.paginatedFilteredUplifts;
  };

  return {
    getUplifts,
  };
}
